import axios from 'axios'
import TabCard from '~/components/TabCard.vue'
import RecipeSvgs from '~/components/RecipeSvgs.vue'

export const recipeBase = {
  components: {
    TabCard,
    RecipeSvgs
  },
  props: {
    recipeName: {
      type: String,
      default: ''
    },
    prePack: {
      type: String,
      default: ''
    },
    postPack: {
      type: String,
      default: ''
    },
    packOnMount: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      payload: '',
      svgs: [],
      response: undefined,
      errors: [],
      tab: '',
      count: '',
      loading: false,
      tabs: ['visual', 'request', 'response']
    }
  },
  computed: {
    initialTab () {
      if (this.packOnMount) {
        return 'visual'
      }
      return 'request'
    },
    selectedTab () {
      if (this.tab === '') {
        return this.initialTab
      } else {
        return this.tab
      }
    },
    boxes () {
      return this.response.boxes.map(b => b.box)
    }
  },
  mounted () {
    if (this.packOnMount) {
      this.loadAndPackRecipe()
    } else {
      this.loadRecipe()
    }
  },
  beforeDestroy () {
    clearInterval(this.loop)
  },
  methods: {
    async loadAndPackRecipe (setTab = 'visual') {
      this.tab = setTab
      await this.loadRecipe()
      await this.pack()
    },
    async loadRecipe () {
      const uri = `https://api.paccurate.io/static/recipes/${this.recipeName}`
      await axios.get(uri).then((response) => {
        this.payload = response.data
      })
    },
    async pack () {
      const uri = 'https://api.paccurate.io/'
      const config = {
        headers: {
          Accept: 'application/json',
          authorization: 'apikey kHyMAEyrbBfn6dBL0rJDt41OLBOXr0Fn'
        }
      }
      const data = this.payload
      this.svgs = []
      this.loading = true
      await axios.post(uri, data, config).then((response) => {
        this.loading = false
        this.response = response.data
        console.log(this.response)
        this.svgs = this.response.svgs
      })
      const boxes = document.getElementsByClassName('box-figure')
      for (const box of boxes) {
        box.className = 'box-figure fastpackani'
      }
    }
  }
}
